<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">申请记录</div>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        style="padding: 20px 30px 0"
      >
        <el-form-item label="申请开始时间">
          <div class="block">
            <!-- <el-date-picker
              style="width: 220px"
              v-model="searchForm.timeRange"
              @change="handleTimeChange"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
            >
            </el-date-picker>-->
            <el-date-picker
              :editable="false"
              v-model="searchForm.startTime"
              :picker-options="startDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择开始日期"
              @change="handleTimeChange"
            />
          </div>
        </el-form-item>
        <el-form-item label="申请结束时间" prop="endTime">
          <el-date-picker
            :editable="false"
            v-model="searchForm.endTime"
            :picker-options="endDatePicker"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择结束日期"
            @change="handleTimeChange"
          />
        </el-form-item>
      </el-form>
      <div style="padding: 0">
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column prop="money" label="产品名称">
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="申请额度">
            <template slot-scope="{ row }">
              <span>{{ row.appLimit }}万</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请时间">
            <template slot-scope="{ row }">
              <!-- <span>{{ $moment(row.createTime).format('YYYY-MM-DD HH:mm')}}</span> -->
              <span>{{row.createTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="500" show-overflow-tooltip />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { applicationList } from "@/api/myCenter";
import TopMessage from "@/components/TopMessage";
import utils from "@/utils/utils.js";
export default {
  components: { TopMessage },
  data() {
    return {
      searchForm: {
        timeRange: [],
        startTime: "",
        endTime: "",
        status: 1
      },
      tableData: [],
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate()
    };
  },
  created() {
    this.getList();
  },
  methods: {
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.searchForm.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.searchForm.startTime).getTime() > time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    getList() {
      applicationList(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.tableData = res.data;
          this.tableData.forEach(item => {
            item.createTime = utils.timestampToTimeLong(item.createTime);
          });
          this.tableData.forEach(x => {
            x.remark =
              "您的需求已推送至平台合作金融机构，将会有业务人员通过您的账号预留电话联系您";
          });
        }
      });
    },
    // 申请时间范围
    handleTimeChange(timeRange) {
      // this.searchForm.startTime = timeRange && timeRange.length ? this.$moment(timeRange[0]).format("YYYY-MM") : "";
      // this.searchForm.endTime = timeRange && timeRange.length ? this.$moment(timeRange[1]).format("YYYY-MM") : "";
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 680px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
/deep/.el-table {
  thead tr th {
    background: #f3f4f9;
  }
  thead tr th:first-child div {
    padding-left: 30px;
  }
  tbody tr td:first-child div {
    padding-left: 30px;
  }
}
</style>
